exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2EAdE6HnMAT-HMKHE8Seqa{min-height:100vh}._2EAdE6HnMAT-HMKHE8Seqa .ais-InstantSearch__root{min-height:100vh;width:100%}._2EAdE6HnMAT-HMKHE8Seqa .ais-InstantSearch__root,._3kHRoq7HvIiIiQMF1N6zOw{display:-webkit-box;display:-ms-flexbox;display:flex}._3qA6HELQHEZgwJ3oCanw8u{width:100%;margin:.5rem 1rem}._3gLBxeGLUsqR_MQQlHyO3J,._3qA6HELQHEZgwJ3oCanw8u,.h5EO6jobAU4KzEcGOqjug{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3gLBxeGLUsqR_MQQlHyO3J{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:20px}.ais-PoweredBy{margin-top:3rem;margin-right:1rem;text-align:right}.ais-PoweredBy-text{font-size:.75em}.ais-PoweredBy-link svg{width:75px;vertical-align:middle}", ""]);

// exports
exports.locals = {
	"root": "_2EAdE6HnMAT-HMKHE8Seqa",
	"searchContainer": "_3kHRoq7HvIiIiQMF1N6zOw",
	"searchBox": "_3qA6HELQHEZgwJ3oCanw8u",
	"filterControls": "h5EO6jobAU4KzEcGOqjug",
	"resultsButtonContainer": "_3gLBxeGLUsqR_MQQlHyO3J"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/postcss-loader!./containers/search.css
 ** module id = 1025
 ** module chunks = 0
 **/